var React = require('react');

function Mark (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#clip0)"},[React.createElement("rect",{"width":"300","height":"300","fill":"","key":0}),React.createElement("circle",{"id":"outer","cx":"150","cy":"150","r":"150","fill":"#1D1D1E","key":1}),React.createElement("circle",{"id":"inner","cx":"141","cy":"181","r":"120","fill":"#f2f9f9","key":2})]));
}

Mark.defaultProps = {"id":"l-mark","width":"300","height":"300","viewBox":"0 0 300 300","fill":"none"};

module.exports = Mark;

Mark.default = Mark;
